function _typeof2(obj) { "@babel/helpers - typeof"; return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import React from 'react';
import StandardModal from './StandardModal';
var isIE = typeof navigator !== 'undefined' && /MSIE|Trident/.test(navigator.userAgent);

var OutdatedBrowserModal = /*#__PURE__*/function (_React$Component) {
  _inherits(OutdatedBrowserModal, _React$Component);

  function OutdatedBrowserModal(props) {
    var _this;

    _classCallCheck(this, OutdatedBrowserModal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OutdatedBrowserModal).call(this, props));
    _this.state = {
      showing: isIE
    };
    _this.toggle = _this.toggle.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(OutdatedBrowserModal, [{
    key: "toggle",
    value: function toggle() {
      this.setState({
        showing: !this.state.showing
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(StandardModal, {
        isOpen: this.state.showing,
        title: "Unsupported browser",
        toggle: this.toggle
      }, /*#__PURE__*/React.createElement("p", null, "We have detected that you are using a browser or device which is not fully supported by our services. While you may continue, please note that your experience will not be optimal."), /*#__PURE__*/React.createElement("p", null, "For the best experience we recommend that you access the service with a desktop browser that adheres to modern standards such as", ' ', /*#__PURE__*/React.createElement("a", {
        href: "https://www.google.com/chrome"
      }, "Google Chrome"), " or", ' ', /*#__PURE__*/React.createElement("a", {
        href: "https://www.getfirefox.com/"
      }, "Mozilla Firefox"), "."));
    }
  }]);

  return OutdatedBrowserModal;
}(React.Component);

export { OutdatedBrowserModal as default };